module.exports = __webpack_public_path__ + "img/swiper3.f471d237.png";